import { render } from "./LifeCycleDocVerCom.vue?vue&type=template&id=63b9fe36"
import script from "./LifeCycleDocVerCom.vue?vue&type=script&lang=js"
export * from "./LifeCycleDocVerCom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__